import type { Scene } from "@babylonjs/core";

export interface AmbientTrack {
  id: string;
  url: string;
  volume?: number;
}

/**
 * Ambient bed + per-vignette one-shot cue playback. No audio assets have
 * been sourced yet (see docs/Castaway Plan.md — a later pass) — this
 * degrades gracefully rather than pretending to work: playing a cue with no
 * backing file logs once (not per-call) and no-ops, so VignettePlayer's
 * audio-cue wiring is fully in place and testable ahead of real audio.
 */
export class AudioManager {
  private readonly scene: Scene;
  private readonly warnedMissing = new Set<string>();

  constructor(scene: Scene) {
    this.scene = scene;
  }

  /** No-op until ambient tracks are sourced. */
  playAmbient(_track: AmbientTrack): void {
    void this.scene; // reserved for the real Babylon sound engine hookup
  }

  playCue(id: string): void {
    if (!this.warnedMissing.has(id)) {
      this.warnedMissing.add(id);
      console.info(`[Castaway] AudioManager: no audio sourced yet for cue "${id}" — skipping.`);
    }
  }

  dispose(): void {
    // Nothing to release until real sound objects exist.
  }
}
